import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
// import LeadsCreateContent from '../../Components/leadsViewCreate/LeadsCreateContent'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import District2Header from './District2Header'
import DistrictCreate from './DistrictCreate'

const EditDistrict = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <District2Header />
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <DistrictCreate />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default EditDistrict